import React, { useRef } from "react";
import { darkTheme } from "@yleisradio/yds-core";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import { UI_SIZE } from "../../enums";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";

const ChromecastOverlayWrapper = styled.div`
  align-items: center;
  color: ${darkTheme.ACTION_PRIMARY};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
`;

const ChromecastOverlayTitle = styled.span<{
  size: UI_SIZE;
}>`
  height: 50px;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: ${props =>
    props.size === UI_SIZE.SMALL || props.size === UI_SIZE.XSMALL
      ? "15px"
      : "32px"};
`;

const ChromecastOverlay = () => {
  const { useStoreState } = usePlayerStore();
  const uiSize = useStoreState.uiSize();

  const { language } = useEmbedParametersContext();

  const chromecastOverlayRef = useRef<HTMLDivElement>(null);

  const castDevice = cast.framework.CastContext.getInstance()
    .getCurrentSession()
    ?.getCastDevice();
  const castTitle = i18n("toistetaan_laitteessa", { language });

  return (
    <div
      onFocus={event => {
        event.stopPropagation();
      }}
      ref={chromecastOverlayRef}
      tabIndex={-1}>
      <ChromecastOverlayWrapper role="dialog">
        <ChromecastOverlayTitle size={uiSize}>
          <google-cast-launcher
            aria-label="chromecast"
            role="button"
            tabIndex={0}
          />
        </ChromecastOverlayTitle>
        <ChromecastOverlayTitle size={uiSize}>
          {"Chromecast"}
        </ChromecastOverlayTitle>
        <p>{castTitle}</p>
        <b>{castDevice?.friendlyName}</b>
      </ChromecastOverlayWrapper>
    </div>
  );
};

export default ChromecastOverlay;
